export class CompanyOverLicensedMachineLimit extends Error {}
